import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyC7tFrGqCi_Bt6vz7zLv9YZZZNlYFltM-o",
  authDomain: "web-portal-2020.firebaseapp.com",
  databaseURL: "https://web-portal-2020.firebaseio.com",
  projectId: "web-portal-2020",
  storageBucket: "web-portal-2020.appspot.com",
  messagingSenderId: "948676108762",
  appId: "1:948676108762:web:52146fc3c20f166da1a0e3",
  measurementId: "G-3NE4ZQL48M"
};
// Initialize Firebase
const init = firebase.initializeApp(firebaseConfig);
// firebase.analytics();

export const db = init.firestore();
export const auth = init.auth();
export const storageRef = firebase.storage().ref();
